@use '../../styles/util' as *;
@use '../../styles/global' as *;

:host {
  @extend %body;

  display: flex;
  height: 100%;
  align-items: center;
}

.sol-avatar {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
}

.sol-avatar__img {
  width: 100%;
  min-height: 100%;
  border-radius: 50%;
  background: none;
  object-fit: cover;
}

.sol-avatar-size20 {
  @extend %body-emphasized;

  width: 20px;
  height: 20px;
  font-size: var(--scale-s1-size); //12px
  line-height: var(--scale-s1-line-height); //16px;
}

.sol-avatar-size24 {
  @extend %body-emphasized;

  width: 24px;
  height: 24px;
  font-size: var(--scale-s1-size); //12px
  line-height: var(--scale-s1-line-height); //16px;
}

.sol-avatar-size28 {
  @extend %body-emphasized;

  width: 28px;
  height: 28px;
  font-size: var(--scale-s2-size); //14px
  line-height: var(--scale-s2-line-height); //20px;
}

.sol-avatar-size32 {
  @extend %body-emphasized;

  width: 32px;
  height: 32px;
  font-size: var(--scale-s2-size); //14px
  line-height: var(--scale-s2-line-height); //20px;
}

.sol-avatar-size36 {
  @extend %body-emphasized;

  width: 36px;
  height: 36px;
  font-size: var(--scale-s3-size); //16px;
  line-height: var(--scale-s3-line-height); //24px;
}

.sol-avatar-size40 {
  @extend %body-emphasized;

  width: 40px;
  height: 40px;
  font-size: var(--scale-s3-size); //16px;
  letter-spacing: -0.04px;
  line-height: var(--scale-s3-line-height); //24px;
}

.sol-avatar-size44 {
  @extend %body-emphasized;

  width: 44px;
  height: 44px;
  font-size: var(--scale-s4-size); //20px;
  letter-spacing: -0.1px;
  line-height: var(--core-type-line-height-200); //32px;
}

.sol-avatar-size56 {
  @extend %body-emphasized;

  width: 56px;
  height: 56px;
  font-size: var(--scale-s4-size); //20px;
  letter-spacing: -0.1px;
  line-height: var(--core-type-line-height-200); //32px;
}

.sol-avatar-background {
  background: var(--surface-base-secondary);
  color: var(--text-base-subdued);
}

.sol-status-indicator {
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 50px;

  &.sol-status-indicator-border20,
  &.sol-status-indicator-border24,
  &.sol-status-indicator-border28,
  &.sol-status-indicator-border32,
  &.sol-status-indicator-border36 {
    right: -1.5px;
    bottom: -1.5px;
  }

  &.sol-status-indicator-border40,
  &.sol-status-indicator-border44,
  &.sol-status-indicator-border56 {
    right: -2px;
    bottom: -2px;
  }
}

.sol-status-indicator-online {
  background-color: var(--icon-rag-success);
}

.sol-status-indicator-busy {
  background-color: var(--icon-rag-danger);
}

.sol-status-indicator-away {
  background-color: var(--icon-base-reversed-subdued);
}

.sol-status-indicator-offline {
  background-color: var(--surface-base-default);
  box-shadow: inset 0 0 0 1.5px var(--icon-base-reversed-subdued);
}

.sol-status-indicator-none {
  display: none;
}

.sol-indicator-border {
  border-style: solid;
  border-color: var(--surface-base-default);
}

.sol-status-indicator-border20,
.sol-status-indicator-border24,
.sol-status-indicator-border28,
.sol-status-indicator-border32,
.sol-status-indicator-border36 {
  border-width: 1.5px;
}

.sol-status-indicator-border40,
.sol-status-indicator-border44,
.sol-status-indicator-border56 {
  border-width: 2px;
}

.sol-status-indicator-size20 {
  width: 6px;
  height: 6px;
}

.sol-status-indicator-size24 {
  width: 6px;
  height: 6px;
}

.sol-status-indicator-size28 {
  width: 6px;
  height: 6px;
}

.sol-status-indicator-size32 {
  width: 8px;
  height: 8px;
}

.sol-status-indicator-size36 {
  width: 10px;
  height: 10px;
}

.sol-status-indicator-size40 {
  width: 10px;
  height: 10px;
}

.sol-status-indicator-size44 {
  width: 12px;
  height: 12px;
}

.sol-status-indicator-size56 {
  width: 16px;
  height: 16px;
}
